import { MfaMethod } from 'dashboard/models/user';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum UserAuthenticationStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
  Expired = 'expired',
}
export interface UserAuthenticationAttributes {
  status: UserAuthenticationStatus;
  'created-at': string;
  'available-mfa-methods'?: MfaMethod[];
}

export interface UserAuthenticationRelationships {
  user: ApiRelationship<ApiModel.User>;
  'user-session': ApiRelationship<ApiModel.UserSession>;
}

export type UserAuthentication = ApiResource<
  UserAuthenticationAttributes,
  UserAuthenticationRelationships,
  ApiModel.UserAuthentication
>;
